import styled from 'styled-components';
import Sider from 'antd/es/layout/Sider';

export const StyledSider = styled(Sider)`
  background-color: white !important;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 85vh;
`;
